/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salary_Col_MinInputs */

const en_salary_col_min = /** @type {(inputs: Salary_Col_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min`)
};

const de_salary_col_min = /** @type {(inputs: Salary_Col_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min`)
};

const fr_salary_col_min = /** @type {(inputs: Salary_Col_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min`)
};

const es_salary_col_min = /** @type {(inputs: Salary_Col_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mín.`)
};

const it_salary_col_min = /** @type {(inputs: Salary_Col_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min`)
};

const nl_salary_col_min = /** @type {(inputs: Salary_Col_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min`)
};

const pl_salary_col_min = /** @type {(inputs: Salary_Col_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min`)
};

const fi_salary_col_min = /** @type {(inputs: Salary_Col_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min`)
};

const da_salary_col_min = /** @type {(inputs: Salary_Col_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min`)
};

const sv_salary_col_min = /** @type {(inputs: Salary_Col_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min`)
};

/**
* | output |
* | --- |
* | "Min" |
*
* @param {Salary_Col_MinInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const salary_col_min = /** @type {((inputs?: Salary_Col_MinInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salary_Col_MinInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_salary_col_min(inputs)
	if (locale === "fr") return fr_salary_col_min(inputs)
	if (locale === "es") return es_salary_col_min(inputs)
	if (locale === "it") return it_salary_col_min(inputs)
	if (locale === "nl") return nl_salary_col_min(inputs)
	if (locale === "pl") return pl_salary_col_min(inputs)
	if (locale === "fi") return fi_salary_col_min(inputs)
	if (locale === "da") return da_salary_col_min(inputs)
	if (locale === "sv") return sv_salary_col_min(inputs)
	return en_salary_col_min(inputs)
});